"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../common");

var ScaleClass =
/*#__PURE__*/
function (_common_1$ObjectClass) {
  _inherits(ScaleClass, _common_1$ObjectClass);

  function ScaleClass() {
    _classCallCheck(this, ScaleClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScaleClass).apply(this, arguments));
  }

  _createClass(ScaleClass, [{
    key: "buildConstraint",
    value: function buildConstraint(data, target, solver) {}
  }, {
    key: "getTemplateParameters",
    value: function getTemplateParameters() {
      return {
        inferences: [{
          objectID: this.object._id,
          scale: {
            classID: this.object.classID,
            expressions: [],
            properties: {
              mapping: "mapping"
            }
          }
        }]
      };
    }
  }]);

  return ScaleClass;
}(common_1.ObjectClass);

exports.ScaleClass = ScaleClass;